"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlpsDAOLogicV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "alps",
        outputs: [
            {
                internalType: "contract AlpsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct AlpsDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "alps_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum AlpsDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract IAlpsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AlpsDAOLogicV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AlpsDAOLogicV1__factory = AlpsDAOLogicV1__factory;
AlpsDAOLogicV1__factory.bytecode = _bytecode;
AlpsDAOLogicV1__factory.abi = _abi;
